<template>
    <select class="dropdown default-element-size" :class="{selected}" v-model="data">
        <option :value="false" disabled selected>{{placeholder}}</option>
        <optgroup v-for="(list, group) of optionList" :label="group" :key="group">
            <option v-for="option of list" :value="option.id" :key="option.id">{{option.name}} - {{option.price}} ₽</option>
        </optgroup>
    </select>
</template>

<script>
    export default {
        name: "dropdown",
        model: {
            prop: 'value',
            event: 'change'
        },
        props: [
            'placeholder',
            'optionList',
            'value'
        ],
        computed: {
            selected(){
                return this.data;
            },
            data: {
                get(){
                    return this.value;
                },
                set(v){
                    this.$emit('change', v);
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    select.dropdown{
        cursor: pointer;
        position: relative;
        appearance: none;
        color: $text_gray;
        background-color: rgba($text_gray, 0.12);
        padding: 0 16px;
        margin-bottom: 24px;

        font-weight: 500;
        font-size: 16px;
        line-height: 19px;

        background-image: url("~@/assets/icons/select_arrow.svg");
        background-repeat: no-repeat;
        background-position: calc(100% - 17px) center;

        transition-duration: 0s !important;

        @include mobile{
            margin-bottom: 20px;
        }
        option, optgroup{
            color: $text_gray;
        }
        &.selected{
            color: white;
        }
        &:focus:hover{
            background-image: url("~@/assets/icons/select_arrow_active.svg");
        }
    }
</style>
